import DatePicker from './DatePicker';

export type { RangeType } from './types';
export type { DatePickerProps } from './DatePicker';
export default DatePicker;
